import moment from 'moment';
import { removeAccents, removeAccentuation } from '@/helpers/string';

export default {
  methods: {
    clone(obj, deep = true) {
      return deep
        ? JSON.parse(JSON.stringify(obj))
        : Object.assign({}, obj);
    },
    onlyNumbers(value, defaultValue = null) {
      let localValue = value;

      switch (typeof localValue) {
        case 'string':
          localValue = localValue.replace(/\D/g, '');
          return localValue === '' ? defaultValue : localValue;
        case 'number':
          return localValue.toString();
        default:
          return defaultValue;
      }
    },
    dateToApi(date, inputFormat = 'L', strict = true) {
      const localDate = moment(date, inputFormat, strict);
      return localDate.isValid() ? localDate.format('YYYY-MM-DD') : null;
    },
    dateFromApi(date, utc = false) {
      const localDate = moment(date);

      if (localDate.isValid()) {
        return utc ? localDate.utc().format('L') : localDate.format('L');
      }
      return null;
    },
    removeAccents,
    removeAccentuation,
    decimalToApi(value, usFormat = false) {
      let number = value;

      if (typeof number === 'string') {
        number = usFormat
          ? number.replace(/,/g, '')
          : number.replace(/\./g, '').replace(',', '.');
        number = Number(number);
      }
      return number || 0;
    },
    createError(message, data = {}) {
      const error = new Error(message);
      Object.keys(data).forEach((key) => {
        error[key] = data[key];
      });
      return error;
    },
  },
};
